/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useForm } from './form'

export const FormSimpleHiddenNumber = ({ name, value, required, shouldDirty }) => {
  const { register, setValue } = useForm(name, { required, valueAsNumber: true, shouldDirty })

  useEffect(
    () => {
      setValue(value)
    },
    [value]
  )

  return (
    <React.Fragment>
      <input type="hidden" {...register()} />
    </React.Fragment>
  )
}
